import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/
import CommonButton from '../components/CommonButton';
class SearchMasterDataDepartment extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation } = props;

        let { faculty_id, department_name, department_status } = Searchs;

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">                  
                        <Row className="mt-3">
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{faculty_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={faculty_id}
                                        option={{source: 'db', data: Masterbase?.faculty}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                        disabled={true}
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{department_name.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={department_name}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{department_status.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={department_status}
                                        option={{source: 'options', section: 'status', item: 'default'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </>
        )
    }
}

export default SearchMasterDataDepartment;